import React from 'react';
import { FaCloud, FaCodeBranch, FaDatabase, FaMobileAlt, FaServer } from 'react-icons/fa';

const pipeline = [
  { label: 'React UI', detail: 'Interfaces and client flows', icon: FaCodeBranch },
  { label: 'Mobile logic', detail: 'App states and device workflows', icon: FaMobileAlt },
  { label: 'API layer', detail: 'Auth, business logic, integrations', icon: FaServer },
  { label: 'Data model', detail: 'Schema, persistence, reporting', icon: FaDatabase },
  { label: 'Cloud deploy', detail: 'Runtime, release, monitoring', icon: FaCloud },
];

function SystemMap() {
  return (
    <section className="portfolioSystemMap sectionReveal" aria-label="System architecture map">
      <div className="portfolioSystemMap__copy">
        <h2>From interface to infrastructure.</h2>
        <p>
          A typical build is mapped as one connected system, so product decisions, backend logic, and deployment constraints stay aligned.
        </p>
      </div>

      <div className="portfolioSystemMap__visual">
        <div className="portfolioSystemMap__trace" aria-hidden="true" />
        {pipeline.map((node, index) => {
          const Icon = node.icon;
          return (
            <article className="portfolioSystemNode" style={{ '--node-index': index }} key={node.label}>
              <Icon />
              <div>
                <h3>{node.label}</h3>
                <p>{node.detail}</p>
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
}

export default SystemMap;
